/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Pnk_TitleInputs */

const vi_sl_pnk_title = /** @type {(inputs: Sl_Pnk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập`)
};

/**

* @param {Sl_Pnk_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_pnk_title = /** @type {((inputs?: Sl_Pnk_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Pnk_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_pnk_title(inputs)
});